export enum RouteNames {
  Landing = "Landing",
  ProgramSelection = "ProgramSelection",
  IdXboxGameInfoDashboard = "IdXboxGameInfoDashboard",
  IdXboxIntro = "IdXboxIntro",
  IdXboxGameInfoForm = "IdXboxGameInfoForm",
  IdXboxWelcome = "IdXboxWelcome",
  IdXboxFormPreview = "IdXboxFormPreview",
  IdAzureHome = "IdAzureDashboard",
  IdAzureIntro = "IdAzureIntro",
  IdAzureWelcome = "IdAzureWelcome",
  IdAzureFormPreview = "IdAzureFormPreview",
  PitchHome = "PitchDashboard",
  PitchWelcome = "PitchWelcome",
  PitchIntro = "PitchIntro",
  PitchInformation = "PitchInformation",
  PitchFormPreview = "PitchFormPreview",
  TestConsole = "TestConsole",
  AaaWelcome = "AaaWelcome",
  AaaDashboard = "AaaDashboard",
  AaaGameInformation = "AaaGameInformation",
  AaaFormPreview = "AaaFormPreview",
  StreamingEu = "StreamingEu",
  StreamingEuEmailVerify = "StreamingEuEmailVerify",
}
